import http from "@/helper/http";
import api from "@/helper/api";

const initialState = () => ({
  stores: [],
  loadingStores: false,
  storesPagination: {
    page: 1,
    perPage: 20,
    total: 0,
    pages: 0,
    hasNext: false,
    hasPrev: false,
  },
  lookupUser: null,
  loadingLookup: false,
  transferring: false,
});

export default {
  namespaced: true,
  state: initialState(),
  mutations: {
    SET_STORES(state, stores) {
      state.stores = stores || [];
    },
    SET_LOADING_STORES(state, loading) {
      state.loadingStores = loading;
    },
    SET_STORES_PAGINATION(state, pagination) {
      state.storesPagination = pagination;
    },
    SET_LOOKUP_USER(state, user) {
      state.lookupUser = user;
    },
    SET_LOADING_LOOKUP(state, loading) {
      state.loadingLookup = loading;
    },
    SET_TRANSFERRING(state, loading) {
      state.transferring = loading;
    },
    RESET_LOOKUP(state) {
      state.lookupUser = null;
    },
    RESET_STATE(state) {
      Object.assign(state, initialState());
    },
  },
  actions: {
    async fetchStores({ commit }, params = {}) {
      commit("SET_LOADING_STORES", true);
      try {
        const response = await http.get(api.admin_jack_stores, { params });
        const data = response?.data || {};
        commit("SET_STORES", data.items || []);
        commit("SET_STORES_PAGINATION", {
          page: data.page || 1,
          perPage: data.per_page || 20,
          total: data.total || 0,
          pages: data.pages || 0,
          hasNext: data.has_next || false,
          hasPrev: data.has_prev || false,
        });
        return data;
      } finally {
        commit("SET_LOADING_STORES", false);
      }
    },
    async lookupUserByPhone({ commit }, phoneNumber) {
      commit("SET_LOADING_LOOKUP", true);
      commit("RESET_LOOKUP");
      try {
        const response = await http.get(api.admin_jack_user_lookup, {
          params: { phone_number: phoneNumber },
        });
        const user = response?.data?.user || null;
        commit("SET_LOOKUP_USER", user);
        return user;
      } finally {
        commit("SET_LOADING_LOOKUP", false);
      }
    },
    async transferOwnership({ commit }, { storeId, newOwnerId }) {
      commit("SET_TRANSFERRING", true);
      try {
        const response = await http.post(
          api.admin_transfer_store_ownership(storeId),
          { new_owner_id: newOwnerId }
        );
        return response?.data?.store || null;
      } finally {
        commit("SET_TRANSFERRING", false);
      }
    },
  },
  getters: {
    stores: (state) => state.stores,
    loadingStores: (state) => state.loadingStores,
    storesPagination: (state) => state.storesPagination,
    lookupUser: (state) => state.lookupUser,
    loadingLookup: (state) => state.loadingLookup,
    transferring: (state) => state.transferring,
  },
};
